import styled from 'styled-components';
import { COLORS, FONTS, SIZE } from '@app/src/ui';
import { Button } from '@app/src/common/Button';
import { CounterAvailableFeature } from '@app/src/common/CounterAvailable';
import { BreadCrumb } from '../BreadCrumb';

interface Props {
  isFixed?: boolean;
}

interface LoggedProps {
  isDisplay?: boolean;
}

const MAIN = 'Header';

export const Wrapper = styled.header`
  &.u-fixed-header {
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    background: #fff;
    position: fixed;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE} ) {
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.3);
  }
`;

Wrapper.displayName = `${MAIN}/Wrapper`;

export const Content = styled.div`
  padding: 0 10px;
  height: 56px;
  display: flex;
  border-bottom: 1px solid ${COLORS.GRAY};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE} ) {
    height: 58px;
    padding: 0 25px;
  }
`;

Content.displayName = `${MAIN}/Content`;

export const Name = styled.div`
  display: none;
  height: 100%;
  position: relative;

  @media (min-width: 920px) {
    display: inline-block;
  }
`;

Name.displayName = `${MAIN}/Name`;

export const InitSessionWrapper = styled.div`
  align-items: center;
  display: none;

  @media (min-width: 920px ) {
    display: flex;
  }
`;

InitSessionWrapper.displayName = `${MAIN}/InitSessionWrapper`;

export const Logged = styled.p`
  font-family: ${FONTS.ROBOTO};
  font-size: 14px;
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 100%
`;

Logged.displayName = `${MAIN}/Logged`;

export const UserName = styled.span`
  font-family: ${FONTS.ROBOTO_BOLD};
  margin-left: 4px;
`;

UserName.displayName = `${MAIN}/UserName`;

export const InitSession = styled.a`
  font-family: ${FONTS.ROBOTO_BOLD};
  font-size: 14px;
  text-decoration: underline;
  color: ${COLORS.BLACK_BOLD};
`;

InitSession.displayName = `${MAIN}/InitSession`;

export const ButtonPackage = styled(Button)`
  text-transform: uppercase;
  font-family: ${FONTS.ROBOTO_BOLD};
  width: 120px;
  font-size: 11px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE} ) {
    font-size: 12px;
    width: 160px;
    margin-left: 32px;
  }
`;

ButtonPackage.displayName = `${MAIN}/ButtonPackage`;

export const Session = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE} ) {
    padding-left: 6px;
  }
`;

Session.displayName = `${MAIN}/Session`;

export const CounterAvailableFeatureResponsive = styled(CounterAvailableFeature)`
  display: block;
  position: relative;
  width: 100%;
  padding: 0 15px;
  @media (min-width: ${SIZE.LARGE_DESKTOP} ) {
    display: none;
  }
`;

CounterAvailableFeatureResponsive.displayName = `${MAIN}/CounterAvailableFeatureResponsive`;

export const BreadCrumbDesktop = styled(BreadCrumb)``;

BreadCrumbDesktop.displayName = `${MAIN}/BreadCrumbDesktop`;

export const Bold = styled.strong`
  color: ${COLORS.GRAY_TEXT};
`;

Bold.displayName = `${MAIN}/Bold`;

export const Step = styled.p`
  font-family: ${FONTS.OPEN_SANS};
  color: ${COLORS.GRAY_PLACEHOLDER};
  margin-left: auto;
  line-height: 56px;
  display: block;
  font-size: 13px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE} ) {
    display: none;
  }
`;

Step.displayName = `${MAIN}/Step`;

export const IconExpand = styled.span`
  margin-left: 4px;
  display: inline-block;
  width: 12px;
  height: 12px;

  ${(props: LoggedProps) => props.isDisplay && `
    transform: rotate(180deg);
  `}
`;

IconExpand.displayName = `${MAIN}/IconExpand`;

export const LoggedMain = styled.div`
  background: #fff;
  border-radius: 0 0 5px 5px;
  font-family: ${FONTS.ROBOTO};
  font-size: 16px;
  color: ${COLORS.BLACK};
  position: absolute;
  width: 160px;
  text-align: right;
  border: 1px solid rgba(0,0,0,.1);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
  right: 0;
  cursor: pointer;
  z-index: 200;

  ${(props: LoggedProps) => props.isDisplay ? `
    display: block;
  ` : `
    display: none;
  `}
`;

LoggedMain.displayName = `${MAIN}/LoggedMain`;

export const Option = styled.div`
  line-height: 44px;
  padding-right: 28px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

Option.displayName = `${MAIN}/Option`;

export const IconExit = styled.span`
  display: inline-flex;
  margin-left: 4px;
`;

IconExit.displayName = `${MAIN}/IconExit`;

export const LoaderWrapper = styled.span`
  right: 0;
  z-index: 10;
  margin-left: 4px;
  svg{
    fill: transparent;
    stroke-width: 5px;
    stroke: #b7b0b0;
    stroke-dasharray: 100%;
    animation: rotate .5s linear infinite;
  }
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`;

LoaderWrapper.displayName = `${MAIN}/LoaderWrapper`;